import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramPatientStatusPage } from './program-patient-status';

@NgModule({
  declarations: [
    ProgramPatientStatusPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramPatientStatusPage),
  ],
})
export class ProgramPatientStatusPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-patient-status/program-patient-status.module.ts